(function () {
    var list = document.querySelector('[data-article-list]');

    if (!list) {
        return;
    }

    var SCOPE = list.getAttribute('data-article-list') || 'articles';
    var STATE_KEY = 'filters:' + SCOPE;
    var RETURN_KEY = 'return:' + SCOPE;
    var STATE_TTL = 30 * 60 * 1000;
    var HIGHLIGHT_MS = 2000;

    var cards = Array.prototype.slice.call(list.querySelectorAll('[data-article-card]'));
    var queryInput = document.querySelector('[data-article-query]');
    var tagSelect = document.querySelector('[data-article-tag]');
    var sortSelect = document.querySelector('[data-article-sort]');
    var releaseToggle = document.querySelector('[data-article-release-toggle]');
    var count = document.querySelector('[data-article-count]');
    var empty = document.querySelector('[data-article-empty]');
    var emptyTitle = document.querySelector('[data-article-empty-title]');
    var reset = document.querySelector('[data-article-reset]');
    var noun = (count && count.getAttribute('data-article-noun')) || 'article';
    var releaseOn = false;

    function normalize(value) {
        return String(value || '').toLowerCase().trim();
    }

    function cardTags(card) {
        return normalize(card.getAttribute('data-article-tags')).split(/\s+/);
    }

    function isRelease(card) {
        return card.getAttribute('data-article-release') === 'true';
    }

    function session(action, key, value) {
        try {
            if (action === 'get') {
                return window.sessionStorage.getItem(key);
            }
            if (action === 'set') {
                window.sessionStorage.setItem(key, value);
                return null;
            }
            window.sessionStorage.removeItem(key);
            return null;
        } catch (error) {
            return null;
        }
    }

    function pruneTagOptions() {
        if (!tagSelect) {
            return;
        }

        var present = {};

        cards.forEach(function (card) {
            cardTags(card).forEach(function (slug) {
                if (slug) {
                    present[slug] = true;
                }
            });
        });

        Array.prototype.slice.call(tagSelect.options).forEach(function (option) {
            if (option.value !== 'all' && !present[option.value]) {
                option.remove();
            }
        });
    }

    function currentState() {
        return {
            search: queryInput ? queryInput.value.trim() : '',
            topic: tagSelect ? tagSelect.value : 'all',
            sort: sortSelect ? sortSelect.value : 'newest',
            important: releaseOn
        };
    }

    function hasOption(value) {
        if (!tagSelect || !value || value === 'all') {
            return false;
        }

        return Array.prototype.slice.call(tagSelect.options).some(function (option) {
            return option.value === value;
        });
    }

    function applyState(state) {
        if (queryInput && typeof state.search === 'string') {
            queryInput.value = state.search;
        }

        if (tagSelect) {
            tagSelect.value = hasOption(state.topic) ? state.topic : 'all';
        }

        if (sortSelect && (state.sort === 'newest' || state.sort === 'oldest')) {
            sortSelect.value = state.sort;
            applySort(state.sort);
        }

        releaseOn = state.important === true;
        paintToggle();
    }

    function stateIsDefault(state) {
        return !state.search && state.topic === 'all' && state.sort === 'newest' && !state.important;
    }

    function syncUrl() {
        if (!window.history || !window.history.replaceState || !window.URL) {
            return;
        }

        var state = currentState();
        var url = new window.URL(window.location.href);
        var params = url.searchParams;

        params.delete('search');
        params.delete('topic');
        params.delete('sort');
        params.delete('important');

        if (state.search) {
            params.set('search', state.search);
        }
        if (state.topic && state.topic !== 'all') {
            params.set('topic', state.topic);
        }
        if (state.sort === 'oldest') {
            params.set('sort', 'oldest');
        }
        if (state.important) {
            params.set('important', 'true');
        }

        window.history.replaceState({}, '', url.pathname + (params.toString() ? '?' + params.toString() : '') + url.hash);
    }

    function persist() {
        var state = currentState();

        if (stateIsDefault(state)) {
            session('remove', STATE_KEY);
            return;
        }

        state.savedAt = new Date().getTime();
        session('set', STATE_KEY, JSON.stringify(state));
    }

    function readUrlState() {
        if (!window.URLSearchParams) {
            return null;
        }

        var params = new window.URLSearchParams(window.location.search);

        if (!params.has('search') && !params.has('topic') && !params.has('sort') && !params.has('important')) {
            return null;
        }

        return {
            search: params.get('search') || '',
            topic: params.get('topic') || 'all',
            sort: params.get('sort') === 'oldest' ? 'oldest' : 'newest',
            important: params.get('important') === 'true'
        };
    }

    function readStoredState() {
        var raw = session('get', STATE_KEY);

        if (!raw) {
            return null;
        }

        try {
            var state = JSON.parse(raw);

            if (!state || typeof state !== 'object') {
                return null;
            }

            if (new Date().getTime() - (state.savedAt || 0) > STATE_TTL) {
                session('remove', STATE_KEY);
                return null;
            }

            return state;
        } catch (error) {
            session('remove', STATE_KEY);
            return null;
        }
    }

    function paintToggle() {
        if (!releaseToggle) {
            return;
        }

        releaseToggle.setAttribute('aria-checked', releaseOn ? 'true' : 'false');
        releaseToggle.classList.toggle('is-on', releaseOn);
    }

    function applyFilters() {
        var query = normalize(queryInput && queryInput.value);
        var tag = (tagSelect && tagSelect.value) || 'all';
        var visible = 0;

        cards.forEach(function (card) {
            var title = normalize(card.getAttribute('data-article-title'));
            var keywords = normalize(card.getAttribute('data-article-keywords'));
            var matchesQuery = !query || title.indexOf(query) >= 0 || keywords.indexOf(query) >= 0;
            var matchesTag = tag === 'all' || cardTags(card).indexOf(tag) >= 0;
            var matchesRelease = !releaseOn || isRelease(card);
            var shouldShow = matchesQuery && matchesTag && matchesRelease;

            card.hidden = !shouldShow;
            visible += shouldShow ? 1 : 0;
        });

        if (count) {
            count.textContent = visible + ' ' + noun + (visible === 1 ? '' : 's');
        }

        if (emptyTitle) {
            emptyTitle.textContent = releaseOn ? 'No Salesforce changes match your filters.' : 'No ' + noun + 's match your filters.';
        }

        if (empty) {
            empty.hidden = visible !== 0;
        }

        list.hidden = visible === 0;

        if (reset) {
            reset.hidden = !(query || tag !== 'all' || releaseOn);
        }
    }

    function commit() {
        applyFilters();
        syncUrl();
        persist();
    }

    function applySort(order) {
        var sorted = cards.slice().sort(function (a, b) {
            var timeA = parseInt(a.getAttribute('data-timestamp'), 10) || 0;
            var timeB = parseInt(b.getAttribute('data-timestamp'), 10) || 0;

            return order === 'oldest' ? timeA - timeB : timeB - timeA;
        });

        sorted.forEach(function (card) {
            list.appendChild(card);
        });
    }

    function restoreReturn() {
        var id = session('get', RETURN_KEY);

        if (!id) {
            return;
        }

        session('remove', RETURN_KEY);

        var card = list.querySelector('[data-article-id="' + id + '"]');

        if (!card || card.hidden) {
            return;
        }

        card.scrollIntoView({block: 'center'});
        card.classList.add('is-returning');

        window.setTimeout(function () {
            card.classList.remove('is-returning');
        }, HIGHLIGHT_MS);
    }

    if (queryInput) {
        queryInput.addEventListener('input', commit);
    }

    if (tagSelect) {
        tagSelect.addEventListener('change', commit);
    }

    if (sortSelect) {
        sortSelect.addEventListener('change', function () {
            applySort(sortSelect.value);
            commit();
        });
    }

    if (releaseToggle) {
        releaseToggle.addEventListener('click', function () {
            releaseOn = !releaseOn;
            paintToggle();
            commit();
        });
    }

    list.addEventListener('click', function (event) {
        var card = event.target.closest ? event.target.closest('[data-article-card]') : null;
        var link = event.target.closest ? event.target.closest('a') : null;

        if (!card || !link || link.classList.contains('topic-pill')) {
            return;
        }

        var id = card.getAttribute('data-article-id');

        if (id) {
            session('set', RETURN_KEY, id);
        }
    });

    if (reset) {
        reset.addEventListener('click', function () {
            if (queryInput) {
                queryInput.value = '';
            }
            if (tagSelect) {
                tagSelect.value = 'all';
            }
            if (sortSelect) {
                sortSelect.value = 'newest';
                applySort('newest');
            }

            releaseOn = false;
            paintToggle();
            commit();
        });
    }

    pruneTagOptions();

    var initial = readUrlState() || readStoredState();

    if (initial) {
        applyState(initial);
    }

    applyFilters();
    syncUrl();
    restoreReturn();
})();
